import { CleanUpDatabaseContainer } from '@/modules/AkeneoSync';

export const CleanUpDatabase = (): JSX.Element => <CleanUpDatabaseContainer />;

export default CleanUpDatabase;
